// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"588":"a8683283","777":"c78d0c0c","787":"cfe3231a"}[chunkId] + ".chunk.js";
};